<template>
    <div class="layout-footer">
        <div @click="handleClick(item)" :class="{ active: item.path === $route.meta.name }" v-for="item in menus">
            <img :src="item.path === $route.meta.name ? item.activeIcon : item.icon" alt=""></img>

            <span>{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'layout-footer',
    data() {
        return {
        }
    },
    computed: {
        menus() {
            return [
                {
                    icon: require('../assets/img/layout/icon-home.png'),
                    activeIcon: require('../assets/img/layout/icon-home-active.png'),
                    title: this.$t('menu.home'),
                    path: 'home',
                },
                {
                    icon: require('../assets/img/layout/icon-alliance.png'),
                    activeIcon: require('../assets/img/layout/icon-alliance-active.png'),
                    title: this.$t('menu.alliance'),
                    path: 'alliance',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-mall.png'),
                    activeIcon: require('../assets/img/layout/icon-mall-active.png'),
                    title: this.$t('menu.mall'),
                    path: 'mall',
                },

                {
                    icon: require('../assets/img/layout/icon-me.png'),
                    activeIcon: require('../assets/img/layout/icon-me-active.png'),
                    title: this.$t('menu.me'),
                    path: 'me',
                },
            ]
        }
    },
    mounted() {

    },
    methods: {
        handleClick(item) {
            if (!item.path) return;
            this.$router.push(item.path)
        }
    },

}
</script>

<style lang="less">
.layout-footer {
    position: fixed;
    height: 88px;
    max-width: 375px;
    display: flex;
    bottom: 0;
    width: 100%;
    background: #F8F9F8;
    padding-bottom: 23px;
    border-radius: 14px 14px 0px 0px;
    z-index: 2;

    >div {
        padding-top: 11px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            margin-bottom: 4px;
        }

        span {
            color: #C4C4C4;
            font-size: 12px;
            line-height: 14px;
        }



        &.active {
            span {
                color: #030303;
            }
        }
    }
}
</style>